'use strict'

export default {
  getGames(cb, errorCb, request = '') {
    axios.get('/amb')
      .then(response => cb(response))
      .catch(err => {
        if (typeof errorCb === 'function') {
          errorCb(err)
        }
      })
  },
  launchGame(cb, data, errorCb) {
    axios.post('/amb/launch', data)
      .then(response => cb(response))
      .catch(err => {
        if (typeof errorCb === 'function') {
          errorCb(err)
        }
      })
  },
}


// WEBPACK FOOTER //
// ./resources/assets/js/admin/api/amb.js